import __request__ from "routing/request";
export function bulkEditInvestigations(JSONBody, requestOptions) {
  return __request__("PUT", "/plugins/org.graylog.plugins.securityapp.investigations/investigations", JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function listInvestigations(sort = "name", page = 1, per_page = 15, query, filters, user_timezone = "UTC", direction = "asc", archived = false, requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.securityapp.investigations/investigations", null, { "page": page, "per_page": per_page, "query": query, "filters": filters, "user_timezone": user_timezone, "sort": sort, "direction": direction, "archived": archived }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function create(JSONBody, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.securityapp.investigations/investigations", JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function bulkArchive(JSONBody, requestOptions) {
  return __request__("PUT", "/plugins/org.graylog.plugins.securityapp.investigations/investigations/archive", JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function archive(id, archive2, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.securityapp.investigations/investigations/archive/${id}/${archive2}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function bulkDeleteInvestigations(JSONBody, requestOptions) {
  return __request__("PUT", "/plugins/org.graylog.plugins.securityapp.investigations/investigations/bulk/delete", JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function addEvidence(JSONBody, requestOptions) {
  return __request__("PUT", "/plugins/org.graylog.plugins.securityapp.investigations/investigations/bulk/evidence/add", JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function removeEvidence(id, JSONBody, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.securityapp.investigations/investigations/evidence/remove/${id}`, JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function updateEvidence(id, JSONBody, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.securityapp.investigations/investigations/evidence/update/${id}`, JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function addEvidenceByidAndJSONBody(id, JSONBody, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.securityapp.investigations/investigations/evidence/${id}`, JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function similarEventEvidence(id, eventId, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.securityapp.investigations/investigations/evidence/${id}/similar/event/${eventId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function similarMessageEvidence(id, index, messageId, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.securityapp.investigations/investigations/evidence/${id}/similar/message/${index}/${messageId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function export_(JSONbody, filename, requestOptions) {
  return __request__("POST", `/plugins/org.graylog.plugins.securityapp.investigations/investigations/export/${filename}`, JSONbody, {}, {
    "Accept": [
      "text/csv",
      "application/json",
      "application/yaml",
      "application/xml",
      "application/vnd.ms-excel"
    ]
  }, requestOptions);
}
export function getFilterOptions(JSONBody, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.securityapp.investigations/investigations/filter_options", JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function listPaginatedInvestigations(page = 1, per_page = 50, query, filters, sort = "created_at", order = "desc", requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.securityapp.investigations/investigations/paginated", null, { "page": page, "per_page": per_page, "query": query, "filters": filters, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function listSlices(slice_column, query, filters, requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.securityapp.investigations/investigations/slices", null, { "slice_column": slice_column, "query": query, "filters": filters }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getInvestigationTeams(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.securityapp.investigations/investigations/teams", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getInvestigationUsers(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.securityapp.investigations/investigations/users", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function editInvestigation(id, JSONBody, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.securityapp.investigations/investigations/${id}`, JSONBody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getInvestigation(id, include_logs_and_events = true, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.securityapp.investigations/investigations/${id}`, null, { "include_logs_and_events": include_logs_and_events }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getAgentTriage(id, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.securityapp.investigations/investigations/${id}/ai-agent-triage`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getLogsPage(id, page = 1, per_page = 20, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.securityapp.investigations/investigations/${id}/logs/paginated`, null, { "page": page, "per_page": per_page }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getSecurityEventsPage(id, page = 1, per_page = 20, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.securityapp.investigations/investigations/${id}/security_events/paginated`, null, { "page": page, "per_page": per_page }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function deleteInvestigation(investigationId, requestOptions) {
  return __request__("DELETE", `/plugins/org.graylog.plugins.securityapp.investigations/investigations/${investigationId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function addNewNote(investigationId, note, requestOptions) {
  return __request__("POST", `/plugins/org.graylog.plugins.securityapp.investigations/investigations/${investigationId}/notes`, note, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function editNote(investigationId, noteId, note, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.securityapp.investigations/investigations/${investigationId}/notes/${noteId}`, note, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function deleteNote(investigationId, noteId, requestOptions) {
  return __request__("DELETE", `/plugins/org.graylog.plugins.securityapp.investigations/investigations/${investigationId}/notes/${noteId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
